export enum OutputSortTypeEnum {
  'RANDOM' = 'RANDOM', // '랜덤순'
  'LOW_USAGE' = 'LOW_USAGE' // '사용량 낮음
}
